<template>
  <div>
    <!-- dialog -->
    <!-- dialog -->
    <!-- top -->
    <van-sticky>
      <van-nav-bar title="公告">
        <template #left>
          <van-icon
            name="arrow-left"
            @click="$router.push($cookie.get('prevPage') || '/')"
          />
        </template>
      </van-nav-bar>
    </van-sticky>
    <!-- top -->
    <div
      class="wrap"
      :style="{
        backgroundImage:
          'url(' +
          $returnColor().path +
          ($store.state.selfData.member_id
            ? '/home-page_bg.png'
            : '/home-page_bg.png') +
          ')',
      }"
    >
      <!-- class="bulletinList" -->
      <van-cell-group
        inset
        v-for="list in annList"
        :key="list.id"
        @click="showContent(list)"
        style="margin-top: 10px"
      >
        <van-cell :title="list.created_at" :label="list.title" />
      </van-cell-group>
      <div v-if="!annList.length" class="noData">暂无公告</div>
      <!-- <van-pagination
        class="paginate"
        v-model="currentPage"
        :page-count="paginate.total_page"
      /> -->
    </div>
    <foot />
  </div>
</template>
<script>
import foot from "../../components/footer";
// import { mapState } from "vuex";
export default {
  components: { foot },
  data() {
    return {
      currentOrder: {},
      setOrderModal: false,
      orderForm: {},
      orderErrorModal: false,
      errorSelect: false,
      errorType: "",
      errorTypeCh: "",
      files: [],
      paginate: {},
      annList: [],
      currentPage: 1,
      current_page: 1,
      next_page: false,
    };
  },
  computed: {},
  watch: {
    currentPage() {
      this.getAnn();
    },
  },
  methods: {
    showContent(list) {
      this.$dialog.confirm({
        title: list.title,
        message: list.content,
        showCancelButton: false,
        messageAlign: "left",
        messageHtml: true,
        className: "edtorW",
      });
    },
    onCopy() {
      this.$toast.success("已复制");
    },
    getAnn() {
      this.$http.get(`/mobile/anns?page=${this.current_page}`).then((res) => {
        if (res.data.code == 0) {
          let listData = JSON.parse(JSON.stringify(this.annList));
          res.data.data.forEach((data) => {
            let have = false;
            this.annList.forEach((e) => {
              if (e.id == data.id) {
                have = true;
              }
            });
            if (!have) {
              listData.push(data);
            }
          });
          this.annList = listData;
          this.next_page = res.data.next_page;
          this.current_page = res.data.current_page;
        }
      });
    },
    scrollPage() {
      if (window.scrollY + window.screen.height >= document.body.scrollHeight) {
        if (this.next_page) {
          this.current_page += 1;
          this.getAnn();
        }
      }
    },
  },
  created() {
    this.getAnn();
  },
  mounted() {
    window.addEventListener("scroll", this.scrollPage);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollPage);
  },
};
</script>

<style lang="scss" scoped>
.paginate {
  margin-top: auto;
  margin-bottom: 30px;
}
.wrap {
  // background-image: url("/home-page_bg.png");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  // background-attachment: fixed;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.footBtn {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
}
.dialogInfo {
  padding: 0 5px;
  color: rgb(219, 99, 101);
  font-size: 14px;
}
.bulletinList {
  position: relative;
  cursor: pointer;
  ::before {
    content: "";
    position: absolute;
    left: 3px;
    width: 8px;
    height: 8px;
    top: 50%;
    transform: translateY(-50%);
    background-color: red;
    border-radius: 50%;
  }
  // background-color: red;
}
.noData {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
